/*
 *		Copyright (c) 2011-2014 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

'use strict';

angular.module('access.Nodes')
    .directive('accSelectNodeFromUrl', ['$location', 'nodeInviteModal', 'nodeRevisionsModal',
        function ($location, nodeInviteModal, nodeRevisionsModal) {
            var
                HIGHLIGHT = 'highlight',
                HIGHLIGHT_UUID = 'highlight_uuid',
                ACTION = 'action',
                ROW_HEIGHT = 52;

            return {
                scope: true,
                controller: ['$scope', '$element', function ($scope, $element) {
                    var
                        searchName = $location.search()[HIGHLIGHT],
                        searchUUID = $location.search()[HIGHLIGHT_UUID],
                        action = $location.search()[ACTION],
                        scrollingElement = $element.parents('.scroller');

                    if (searchName || searchUUID) {
                        var
                            done = false,
                            stopSearching = $scope.$watchCollection('table.filteredEntries', function (entries) {
                                if ((entries || []).length === 0) return; // goes through 'undefined' and '[]' states, so we skip them

                                for (var i = 0; i < entries.length; i++) {
                                    if (entries[i].name === searchName || entries[i].uuid === searchUUID) {
                                        $scope.node = entries[i];

                                        if (angular.isFunction($scope.resetMultiSelect)) {
                                            $scope.resetMultiSelect();
                                        }
                                        $scope.toggleSelect($scope.node);

                                        if (action === 'invite') {
                                            nodeInviteModal($scope);
                                        } else if (action === 'revisions') {
                                            nodeRevisionsModal($scope);
                                        }

                                        done = true;
                                        stopSearching();
                                        scrollingElement.scrollTop(i * ROW_HEIGHT); // bring the found node into view

                                        break;
                                    }
                                }

                                if (!done) {
                                    $scope.table.loadMore(); // keep on loading until we find it or run out of nodes
                                }
                            });

                        $location.search(HIGHLIGHT, null);
                        $location.search(HIGHLIGHT_UUID, null);
                        $location.search(ACTION, null);
                    }
                }]
            }
        }
    ]);
